
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/chartmogul",
      function () {
        return require("private-next-pages/destinations/chartmogul.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/chartmogul"])
      });
    }
  